<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :label-width="100"
            :rules="ruleValidate"
            :viewonly="false"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="contractTplId" label="合同模板">
                        <Select
                            v-model="info.contractTplId"
                            :disabled="true"
                            transfer
                        >
                            <Option
                                v-for="item in contractTplList"
                                :value="item.id"
                                :key="item.id"
                            >
                                {{ item.tplName }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="houseId" label="房源名称">
                        <form-lookup
                            v-model="info.houseId"
                            placeholder="请选择"
                            title="选择房间"
                            textSymbol="title"
                            valueSymbol="id"
                            :modalHeight="600"
                            :modalWidth="900"
                            :options.sync="lookupOptions.houseId"
                            :viewonly="true"
                            :disabled="true"
                        >
                            <select-room />
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <!-- 不显示，仅为收集数据 -->
            <Row :gutter="20" v-show="false">
                <Col span="12">
                    <FormItem prop="houseName" label="房源名称">
                        <Input v-model="info.houseName"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="contractType" label="合同类型">
                        <Input v-model="info.contractType"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="contractCode" label="合同编码">
                        <Input v-model="info.contractCode"></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import { deepCopy } from '_u/helper'
import { contractView, contractUpdate } from '@/api/contract'
import { contractTplList } from '@/api/configuration'
import SelectRoom from '_vc/select-room'

export default {
    name: 'ChangeContractInfo',

    props: {
        id: {
            type: [Number, String],
            default: '',
        },
    },
    components: { SelectRoom },

    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id, // 合同编号
                houseId: '', // 房源编号
                houseName: '', // 房源名称
                contractTplId: '', // 模板编号
                contractCode: '', // 合同编码
                contractType: '', // 合同类型
                ver: '', // 版本号
            },
            lookupOptions: {
                houseId: [],
            },
            contractTplList: [], //合同模板列表
        }
    },
    computed: {
        ruleValidate() {
            return {
                contractTplId: [{ required: true, message: '合同模板必填' }],
                houseId: [{ required: true, message: '房源名称必填' }],
                contractCode: [{ required: true, message: '合同编码必填' }],
            }
        },
    },
    watch: {
        'info.contractTplId'(val) {
            const contract = this.contractTplList.find((v) => v.id === val)
            if (contract) {
                this.info.contractType = contract.tplType
            }
        },
    },
    mounted() {
        var $info = this.$refs.info
        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]
        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        this.$modal.beforeEnter((next) => {
            Promise.all([
                contractView(this.id),
                contractTplList({ pageNo: 1, pageSize: 999 }),
            ])
                .then((args) => {
                    var [view, list] = args

                    if (view) {
                        var viewData = view.data.entity
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                        this.lookupOptions.houseId.push({
                            id: this.info.houseId,
                            title: this.info.houseName,
                        })

                        this.contractTplList = list.data.page.list
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    return contractUpdate(deepCopy(this.info))
                })
                .then((res) => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="scss" scoped></style>
